import { Component } from '@angular/core';
import { CardItemComponent } from '../../UI/card-item/card-item.component';
@Component({
  selector: 'app-static-card-flash',
  imports: [CardItemComponent],
  templateUrl: './static-card-flash.component.html',
  styleUrl: './static-card-flash.component.css'
})
export class StaticCardFlashComponent {

  cardItems: any[] =
    [
      {
        icon: 'Images/card1.jpg',
        name: '1. Test Yourself First',
        discrption: 'Flip the card only after you’ve genuinely tried to recall the answer. Active recall strengthens memory far more than passive reading.'
      }
      ,
      {
        icon: 'Images/card2.jpg',
        name: '2. Space Out Your Practice',
        discrption: 'Revisit the cards regularly rather than all at once. Spaced repetition helps you remember information for longer and reduces exam-time stress.'
      },
      {
        icon: 'Images/card3.jpg',

        name: '3. Track What You Don’t Know',
        discrption: 'Sort cards into “easy” and “needs review” piles. Focus more time on the tricky ones to turn weak areas into strengths.'
      }
    ]
}
